import { AsyncPipe, CommonModule, Location, NgClass } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { DocumentData } from "@angular/fire/firestore";
import { MatDialog } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { ActivatedRoute, Data, Router } from "@angular/router";
import { isMobile } from "@core/utility.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { from, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { bounceIn } from "src/app/animations/custom.animation";
import { CommonVariable } from "src/app/app.constants";
import { WindowsGamePlayPopupComponent } from "src/app/components/windows-game-play-popup/windows-game-play-popup.component";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { InProgressAnimationComponent } from "../../../components/in-progress-animation/in-progress-animation.component";
import { GamesRepositoryService } from "../games-repository.service";
import { GameDatasService } from "../services/game-data.service";
import { GamePlayBaseComponent } from "../shared/game-play-base.component";

const zeroIndex = 0; //defined constant variable;
const oneIndex = 1; //defined constant variable;
@Component({
  selector: "app-instant-win-game",
  templateUrl: "./instant-win-game.component.html",
  styleUrls: ["./instant-win-game.component.scss"],
  animations: [bounceIn],
  standalone: true,
  imports: [
    IonicModule,
    NgClass,
    MatProgressSpinner,
    MatIcon,
    InProgressAnimationComponent,
    AsyncPipe,
    TranslatePipe,
    CommonModule,
  ],
})
export class InstantWinGameComponent extends GamePlayBaseComponent implements OnInit {
  public gameTopPrize: string;
  public intTopPrize: string;
  public flashCost: Data;
  flashSaleEnabled: boolean;
  flashSalesExpiryDate: Data;
  salesCost: number | string;
  gameInfo$ = this.gameDatasService?.getGameInfo(this.route.snapshot.params.id, "instant_win").pipe(
    switchMap((res: DocumentData[]) => {
      const gameData = res.map((element) => element?.data()); // Modular SDK: .data() instead of .payload.data()

      const preferredCurrency = this.preferredCurrency ?? CommonVariable.preferredCurrency;

      if (gameData && gameData[oneIndex]) {
        const flashSaleDetails = gameData[oneIndex]?.sale_details;

        const saleDetails = this.gameDatasService?.getFlashSaleData(flashSaleDetails);

        this.flashSalesExpiryDate = saleDetails.flash_sale_date;
        this.salesCost = this.authService?.flashSaleEnabled ? saleDetails?.sales_cost : '';
        this.flashSaleEnabled = this.gameDatasService?.isFlashSaleToday(this.flashSalesExpiryDate);


        const inputData = {
          myString: gameData[oneIndex],
          currency: preferredCurrency
        };

        return from(this.authService.getDvResolvedJson(inputData)).pipe(
          map((resp: Data) => {
            gameData[oneIndex] = resp?.data;
            gameData[zeroIndex] = gameData[zeroIndex]
              ? { ...gameData[zeroIndex], cc: '44' }
              : { cc: '44' };


            this.getPriceList(gameData);

            const orientation = gameData[zeroIndex]?.orientation ?? gameData[oneIndex]?.orientation;
            this.gameService.setCurrentGameOrientationStatus(orientation);

            return { ...gameData[zeroIndex], ...gameData[oneIndex] };
          }),
          catchError((err) => {
           
            return of(err);
          })
        );
      } else {
     
        return of({});
      }
    }),
    catchError((err) => {
      
      return of({});
    })
  );

  public priceList: Data = [];
  public popupDetails: string;
  public learnMoreRules: string;
  languageCode: string;
  userGameRestriction: boolean;
  public gamesWithNoPrize: number[] = [];
  public hidePrizeHeading: number = null;
  userId: string;

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private gameService: GamesRepositoryService,
    private analytics: AngularFireAnalytics,
    public dialog: MatDialog,
    public translate: TranslateService,
    private GTMSegment: GTMSegmentService,
    private router: Router,
    private gameDatasService: GameDatasService

  ) {
    super()
  }

  async ngOnInit() {
    super.ngOnInit();
    this.languageCode = this.selectedLanguage || "en";
    await this.authService
      ?.getUid("InstantWinGameComponent")
      ?.then((uid) => {
        this.userId = uid;
        this.analytics.logEvent("instant_win_game_screen", {
          userId: this.userId
        });
      })
      .catch((error) => {
        return error;
      });
    this.gamesWithNoPrize = [...this.gameService.gamesWithNoPrize];
    const navigation = this.router.getCurrentNavigation();
    this.flashCost = navigation?.extras.state;
  }

  public getTopPrice(gameDetails: Data): void {
    const one = 1;
    const therr = 353;

    if (gameDetails?.int_top_prize) {
      this.authService
        .getDVFromString(gameDetails?.int_top_prize[this.languageCode])
        .then((resp: string) => {
          gameDetails.gameTopPrice = resp;
        })
        .catch((err) => {
          return err;
        });

      return gameDetails.gameTopPrice;
    } else {
      return this.preferredCurrency == "CAD"
        ? gameDetails?.country_code_data[one]?.top_prize
        : this.preferredCurrency == "EUR"
          ? gameDetails?.country_code_data[therr]?.top_prize
          : gameDetails?.country_code_data[gameDetails?.cc]?.top_prize;
    }
  }

  public getPriceList(priceList: Data): void {
    const one = 1;
    // const therr = 353;
    const defaultCurrency = 44;
    const cc = priceList?.cc ? priceList?.cc : defaultCurrency;
    if (priceList) {
      //   if (priceList[one]?.int_prize_list) {
      //     const prizeListObj = priceList[one].int_prize_list;
      //     const zeroNum = 0;
      //     if (Object.keys(prizeListObj).length > zeroNum) {
      //       for (const [key, value] of Object.entries(prizeListObj)) {
      //         const prizeList = value[this.languageCode];
      //         this.authService
      //           .getDVFromString(prizeList)
      //           .then((resp: string) => {
      //             this.priceList[key] = resp;
      //           })
      //           .catch((err) => {
      //             return err;
      //           });
      //       }
      //     }
      //   } else {
      //     const prizeList =
      //       this.preferredCurrency == "CAD"
      //         ? priceList[one]?.country_code_data[one]?.prize_list
      //         : this.preferredCurrency == "EUR"
      //         ? priceList[one]?.country_code_data[therr]?.prize_list
      //         : priceList[one]?.country_code_data[cc]?.prize_list;
      //     prizeList.map((res, index) => {
      //       this.authService
      //         .getDVFromString(res)
      //         .then((resp: string) => {
      //           this.priceList[index] = resp;
      //         })
      //         .catch((err) => {
      //           return err;
      //         });
      //     });
      //   }

      //   if (priceList[one]?.int_game_popup_details) {
      //     this.authService
      //       .getDVFromString(priceList[one]?.int_game_popup_details[this.languageCode])
      //       .then((resp: string) => {
      //         this.popupDetails = resp;
      //       })
      //       .catch((err) => {
      //         return err;
      //       });
      //   } else {
      //     const gamePopupDetails =
      //       this.preferredCurrency == "CAD"
      //         ? priceList[one]?.country_code_data[one]?.game_popup_details
      //         : this.preferredCurrency == "EUR"
      //         ? priceList[one]?.country_code_data[therr]?.game_popup_details
      //         : priceList[one]?.country_code_data[cc]?.game_popup_details;
      //     this.authService
      //       .getDVFromString(gamePopupDetails)
      //       .then((resp: string) => {
      //         this.popupDetails = resp;
      //       })
      //       .catch((err) => {
      //         return err;
      //       });
      //   }

      const prizeListObj = priceList[one]?.int_prize_list;
      const defaultPrizeList = priceList[one]?.prize_list;
      const zeroNum = 0;
      if (priceList[one]?.int_prize_list && Object.keys(prizeListObj).length > zeroNum) {
        for (const [key, value] of Object.entries(prizeListObj)) {
          const selectedLanguageOrDefault = this.selectedLanguage || 'en';
          const prizeList = value[selectedLanguageOrDefault];
          this.priceList[key] = prizeList;
        }
      } else if (defaultPrizeList && Object.keys(defaultPrizeList).length > zeroNum) {
        this.priceList = defaultPrizeList;
      }
      const selectedLanguageOrDefault = this.selectedLanguage || 'en';
      const learnMoreDetails = priceList[one]?.int_learn_more_details
        ? priceList[one]?.int_learn_more_details[selectedLanguageOrDefault]
        : priceList[one]?.learn_more_details;
      if (learnMoreDetails) {
        this.popupDetails = learnMoreDetails;
      } else if (priceList[one]?.int_game_popup_details) {
        this.popupDetails = priceList[one]?.int_game_popup_details[this.selectedLanguage];
      } /* else {
        const gamePopupDetails =
          this.preferredCurrency == "CAD"
            ? priceList[one]?.country_code_data[one]?.game_popup_details
            : this.preferredCurrency == "EUR"
              ? priceList[one]?.country_code_data[therr]?.game_popup_details
              : priceList[one]?.country_code_data[cc]?.game_popup_details;
        this.popupDetails = gamePopupDetails;
      }
 */
      const learnMoreRules = priceList[one]?.int_learn_more_rules
        ? priceList[one]?.int_learn_more_rules[selectedLanguageOrDefault]
        : priceList[one]?.learn_more_rules;
      if (learnMoreRules) {
        this.learnMoreRules = learnMoreRules;
      }

      if (priceList[one]?.int_top_prize) {
        this.gameTopPrize = priceList[one]?.int_top_prize[this.selectedLanguage];
      } else if (priceList[one]?.top_prize) {
        this.gameTopPrize = priceList[one]?.top_prize[this.selectedLanguage];
      }
      /* else {
       const gameTopPrize =
         this.preferredCurrency == "CAD"
           ? priceList[one]?.country_code_data[one]?.top_prize
           : this.preferredCurrency == "EUR"
             ? priceList[one]?.country_code_data[therr]?.top_prize
             : priceList[one]?.country_code_data[cc]?.top_prize;
       this.gameTopPrize = gameTopPrize;
     } */
    }
  }

  async playGame(game: any) {
    const gamePrice = game?.sale_price || game?.game_price;
    if (!this.userGameRestriction) {
      this.isButtonDisabled = true;
      this.GTMSegment.HotJarEvent("user_played_game");
      if (!isMobile.any() && game?.orientation == "landscape") {
        this.dialog.open(WindowsGamePlayPopupComponent);
        return null;
      }
      game.document = "/api_post_request/customer_game_token_authentication";
      game.from_page = "instant-win";
      game.user_game_restriction = this.userGameRestriction;
      this.playGameBase(game);
    } else {
      this.isButtonDisabled = false;
      // this.authGamesService?.callDedicatedInboxMessage();
      this.authService.getConstantsMsg("1148")
        .then((translatedMsg) => {
          const message = "You have reached the game play limit";
          const defaultMsg = {
            message: {
              line_1: message,
              line_2: "",
            },
            style: {
              icon: "tick circle error.svg",
              type: "Error",
            },
          };
          this.authService.showToastMessage(translatedMsg, defaultMsg);
        })
        .catch((error) => {
          return error;
        });
    }
  }

  compareFn(a: any, b: any): number {
    return a.key.localeCompare(b.key);
  }

  goBack() {
    this.location.back();
  }
}
